import React, { useState, useEffect } from 'react';

const SelectableAttributes = ({ attributes, onPriceChange }) => {
    // Initialize state with default true for all attributes
    const [selectedAttributes, setSelectedAttributes] = useState(
      Object.keys(attributes).reduce((acc, key) => {
        acc[key] = true; // Default all checkboxes to true (checked)
        return acc;
      }, {})
    );
  
    // Calculate initial total price when component mounts
    useEffect(() => {
      calculateTotalPrice();
    }, []);
  
    // Handle checkbox change
    const handleCheckboxChange = (attribute) => {
      setSelectedAttributes((prevState) => {
        const updatedState = { ...prevState, [attribute]: !prevState[attribute] };
        calculateTotalPrice(updatedState); // Recalculate price based on new state
        return updatedState;
      });
    };
  
    // Calculate total price of selected attributes
    const calculateTotalPrice = (state = selectedAttributes) => {
        const allChecked = Object.values(state).every((isChecked) => isChecked);
        if (allChecked) {
          onPriceChange(0); // If all are checked, set price to 0 (or no change)
          return;
        }
        // Calculate the total price of checked attributes if not all are checked
        const total = Object.entries(state)
          .filter(([_, isChecked]) => isChecked) // Only include checked attributes
          .reduce((sum, [key]) => sum + parseFloat(attributes[key][0]), 0);
      
        onPriceChange(total); // Notify parent of the new total
    };
  
    return (
        <div className="flex flex-wrap gap-4">
          {Object.entries(attributes).map(([name, priceArray]) => (
            <div
              key={name}
              className="flex items-center p-1 bg-gray-100 rounded-md shadow-md w-full sm:w-1/2 lg:w-1/3 xl:w-1/4 overflow-hidden"
            >
              <input
                type="checkbox"
                checked={selectedAttributes[name]}
                onChange={() => handleCheckboxChange(name)}
                className="w-5 h-5 text-blue-600 focus:ring-2 focus:ring-blue-500 rounded border-gray-300 mr-2"
                style={{appearance:'auto'}}
              />
      
              {/* Wrap text inside a flex container */}
              <div className="flex items-center justify-between flex-1 min-w-0">
                <span className="font-semibold truncate text-xs">{name}:</span>
                <span className="ml-2 text-green-600 truncate text-xs">${priceArray[0]}</span>
            </div>
            </div>
          ))}
        </div>
      );
      
  };

export default SelectableAttributes;
